import { FC } from 'react'

import styled from 'styled-components'

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

const Title = styled.h2`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin: 0;
`

export const AdsArtistsModalHeader: FC = () => (
  <Header>
    <Title>Similar artists</Title>
  </Header>
)
